"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Batchers = void 0;
const definitions_1 = require("@ppay/definitions");
const network_1 = require("./network");
exports.Batchers = [
    {
        blockchain: definitions_1.Blockchain.ETHEREUM,
        [network_1.Network.main]: '0x1631133E4342302ED3cC41D1AE2428396921933a',
        [network_1.Network.test]: '0xF2d0139E868809F456e9cAE4B627B8f32DdCCc7D'
    },
    {
        blockchain: definitions_1.Blockchain.BINANCE_SMART_CHAIN,
        [network_1.Network.main]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e',
        [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
    },
    {
        blockchain: definitions_1.Blockchain.POLYGON,
        [network_1.Network.main]: '0x74e0E03d8f3730BF91A956613B6cc9e7B49e736C',
        [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
    }
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmF0Y2hlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9iYXRjaGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1EQUE4QztBQUU5Qyx1Q0FBbUM7QUFRdEIsUUFBQSxRQUFRLEdBQWM7SUFDakM7UUFDRSxVQUFVLEVBQUUsd0JBQVUsQ0FBQyxRQUFRO1FBQy9CLENBQUMsaUJBQU8sQ0FBQyxJQUFJLENBQUMsRUFBRSw0Q0FBNEM7UUFDNUQsQ0FBQyxpQkFBTyxDQUFDLElBQUksQ0FBQyxFQUFFLDRDQUE0QztLQUM3RDtJQUNEO1FBQ0UsVUFBVSxFQUFFLHdCQUFVLENBQUMsbUJBQW1CO1FBQzFDLENBQUMsaUJBQU8sQ0FBQyxJQUFJLENBQUMsRUFBRSw0Q0FBNEM7UUFDNUQsQ0FBQyxpQkFBTyxDQUFDLElBQUksQ0FBQyxFQUFFLDRDQUE0QztLQUM3RDtJQUNEO1FBQ0UsVUFBVSxFQUFFLHdCQUFVLENBQUMsT0FBTztRQUM5QixDQUFDLGlCQUFPLENBQUMsSUFBSSxDQUFDLEVBQUUsNENBQTRDO1FBQzVELENBQUMsaUJBQU8sQ0FBQyxJQUFJLENBQUMsRUFBRSw0Q0FBNEM7S0FDN0Q7Q0FDRixDQUFBIn0=